
<div class="loading-shade" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
</div>
<div mat-dialog-title class="grid">
  <div class="column-title">
    <span>Exportar Datos De DWHO</span>
  </div>
  <div class="column-close changecolorclose">
    <button mat-button [mat-dialog-close]="false">
      <mat-icon class="material-icons-outlined icon-close">close</mat-icon>
    </button>
  </div>
</div>
<div mat-dialog-content>
  <mat-form-field appearance="fill">
    <mat-label>Seleccione una <b>Fecha de Incio</b></mat-label>
    <input matInput [matDatepicker]="startDatePicker" [(ngModel)]="startDate">
    <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #startDatePicker></mat-datepicker>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Seleccione una <b>Fecha de Fin</b></mat-label>
    <input matInput [matDatepicker]="endDatePicker" [(ngModel)]="endDate">
    <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #endDatePicker></mat-datepicker>
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false" class="no-button">Cancelar</button>
  <span [matTooltip]="buildTooltip()">
    <button mat-button [mat-dialog-close]="true" [disabled] ="startDate && endDate ? false : true" class="yes-button" (click)="validatDataAndDownloadFile()">Descargar Archivo</button>
  </span>
</div>